// Auth state — mirrors reference auth.store pattern
// Structured User model, session tracking, credits, initialization flag
import { createMapStore } from '@lib/state/store.js';

/**
 * User model shape:
 * {
 *   id: string,
 *   email: string,
 *   fullName?: string,
 *   avatarUrl?: string,
 *   createdAt?: string,
 * }
 */

export const authStore = createMapStore({
  // Core auth
  user: null,           // User object | null
  session: null,        // { accessToken, refreshToken, expiresAt } | null
  subscription: null,   // Subscription row | null
  isAuthenticated: false,
  isLoading: false,
  isInitialized: false, // true after first auth check (blocks UI via AuthGate)
  error: null,

  // Credits (fetched after login, kept in memory)
  credits: 0,
  isCreditsLoading: false,
});

/**
 * Convenience: derive token from session
 * @returns {string|null}
 */
export function getToken() {
  const { session } = authStore.get();
  return session?.accessToken ?? null;
}

/**
 * Check if user is currently authenticated
 * @returns {boolean}
 */
export function isAuthenticated() {
  return authStore.get().isAuthenticated;
}
